export default __webpack_public_path__ + "static/media/archive_image.fb9234cd.jpg";